/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { isA11yClick } from '../../util/accessabilityUtils';
import { helpModalControl } from '../modals/HelpModalControl';
import { helpModalIndex } from '../modals/helpModalIndex';

class ColumnUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.id = `i${uuid()}`;
  }

  handleHelpClick(e) {
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId && isA11yClick(e)) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const { children, helpModalId } = this.props;
    let columnHeading = 'Column Info';
    const tooltip = helpModalIndex[helpModalId];
    if (tooltip !== undefined) {
      columnHeading = `${tooltip.title}`;
    }

    if (helpModalId) {
      return (
        <div
          id={this.id}
          className="haz-grid-column-help"
          tabIndex={0}
          role="button"
          aria-label={columnHeading}
          aria-hidden="false"
          onClick={this.handleHelpClick}
          onKeyDown={this.handleHelpClick}
        >
          {children}
        </div>
      );
    }

    return (
      <div>
        {children}
      </div>
    );
  }
}

ColumnUnwrapped.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  cell: PropTypes.func,
  width: PropTypes.number.isRequired,
  sortable: PropTypes.bool,
  displayName: PropTypes.string,
  alwaysVisible: PropTypes.bool,
  downloadable: PropTypes.bool,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
};

ColumnUnwrapped.defaultProps = {
  cell: config => (<div>{config.value}</div>),
  sortable: false,
  displayName: '',
  alwaysVisible: false,
  downloadable: true,
  helpModalId: '',
};

export const Column = helpModalControl(ColumnUnwrapped);

Column.defaultProps = ColumnUnwrapped.defaultProps;
